import gql from "graphql-tag"

export const setUserBehavioursMutation = gql`
  mutation setUserBehaviours($eventLabel: String!, $eventValue: String!, $user_id: String!) {
    set_user_behaviours(event_label: $eventLabel, value: $eventValue, user_id: $user_id) {
      id
      user_id
      event_label
      value
      created_at
    }
  }
`
